import createReactClass from 'create-react-class';

const tools = require('form/tools')();

export default function (uniqueId = id => id) {
    return createReactClass({
        render: function () {
            var config = this.props.config;
            var state = this.props.state;
            var className = this.props.classProps;
            var formatted = format(state.value, config);
            if (config.maxReplacer !== undefined && state.value >= config.max) {
                formatted = config.maxReplacer;
            }

            var type = (tools.isNumber(config.format) || config.format === "phone") ? "tel" : "text";
            return <input style={{ "WebkitUserSelect": "auto" }} id={uniqueId(config.id)} className={className} disabled={config.disabled} type={type} autoComplete={config.autoComplete} value={formatted} min={config.min} max={config.max} step={config.step} onKeyDown={this.onEvent.bind(this, keyDown)} onKeyPress={this.onEvent.bind(this, keyPress)} placeholder={config.placeholder} maxLength={config.maxLength} onChange={this.onEvent.bind(this, handleChange)} />;
        },
        onEvent: function (handler, event) {

            var didUpdate = handler(event, this.props.config, this.props.state);
            if (didUpdate && this.props.onUpdate) this.props.onUpdate();
        }
    });
};

function handleChange(event, config, state) {
    var cleanedValue = convertString(event.target.value, config.format, config.suffix);
    state.value = cleanedValue;
    return true;
}

function toString(obj) {
    return Object.keys(obj).reduce((dict, key) => {
        dict[key] = obj[key];
        return dict;
    }, {});
}

function keyDown(event, config, state) {
    return handleKeyEvent(event, config, state, "keyDown");
}

function keyPress(event, config, state) {
    return handleKeyEvent(event, config, state, "keyPress");
}

function throwEvent(event) {
    var trans = Object.keys(event).reduce((dict, key) => {
        if (typeof event[key] !== "object") dict[key] = event[key];
        return dict;
    }, {});

    setTimeout(() => {
        throw new Error(JSON.stringify(trans));
    }, 0);
}

function handleKeyEvent(event, config, state, type) {
    var field = event.target;
    var position = getPosition(event, type);

    if (position !== null) {

        var { start, end } = getSelection(event.target, config);

        if (!(start === 0 && config.autoComplete)) {
            event.preventDefault();
            updateField(event, config, state, position);
        }

        return true;
    }
    else return false;
}


function getPosition(event, type) {
    if (type === "keyDown" && event.keyCode === 8) { //Backspace
        return [-1, -1];
    }
    else if (type === "keyDown" && event.keyCode === 46) { //Delete
        return [1, 0];
    }
    else if (type === "keyPress" && event.charCode !== 0 && !isModifierKey(event)) {
        return [0, 1];
    }
    else return null;
}

function updateField(event, config, state, position, offset = 0) {
    var field = event.target;
    var [insertPos, selectPos] = position;
    var { start, end } = getSelection(field, config, offset);
    var { end: maxLength } = getAllowedPositionRange(field, config)


    var character = String.fromCharCode(event.charCode);

    var nextValue = insertIntoText(insertPos === 0 ? character : '', field.value, {
        start: Math.min(start, start + insertPos),
        end: Math.max(end, end + insertPos),
    });


    var cleanedValue = convertString(nextValue, config.format, config.suffix);
    var formattedValue = format(cleanedValue, config);
    if (config.maxReplacer !== undefined && state.value >= config.max) {
        formattedValue = config.maxReplacer;
    }
    var nextPosition = getNextPosition(field, selectPos, formattedValue, config, offset);
    var nextOffset = getOffset(selectPos, config);

    if (formattedValue === field.value && selectPos < 1 && nextOffset && offset === 0 && start !== 0) {
        updateField(event, config, state, position, nextOffset);
    }
    else if (selectPos === 1 && config.maxLength !== undefined &&
        state.value.length === config.maxLength &&
        start === end) {
    }
    else {
        state.value = cleanedValue;
        field.value = formattedValue;
        field.setSelectionRange(nextPosition, nextPosition);
    }
}

function getOffset(selectPos, config) {
    return (config.thousands || "").length * getSign(selectPos);
}

function getSign(value) {
    return value < 0 ? -1 : 1;
}


function insertIntoText(source, target, { start, end }) {
    return target.substring(0, start) + source + target.substring(end);
}


function getSelection(field, config, offset = 0) {
    var { end } = getAllowedPositionRange(field, config)
    return {
        start: Math.min(field.selectionStart + offset, end),
        end: Math.min(field.selectionEnd + offset, end)
    };
}

function getAllowedPositionRange(field, config) {
    var suffixLength = (config.suffix || "").length;

    var maxPosition = field.value.length - (suffixLength ? config.plusSign ? suffixLength : suffixLength + 1 : 0);
    return {
        end: Math.max(maxPosition, 0)
    };
}

function isModifierKey(event) {
    var keys = ["altKey", "ctrlKey", "metaKey"];
    return keys.reduce((bool, key) => {
        return bool || event[key];
    }, false);
}

function filterOnRegExp(text, regexp) {
    return Array.prototype.filter.call(String(text), function (character) {
        return character.match(regexp);
    }).join('');
}

function onlyInteger(value) {
    return filterOnRegExp(value, /[0-9]/);
}


function onlyDecimal(value) {
    var onlyValidChars = filterOnRegExp(value, /[0-9,.]/);

    var onlyComma = onlyValidChars.replace(/,/g, '.');
    var beforeComma = onlyComma.split(".")[0];
    return beforeComma + getAfterComma(onlyComma);

    function getAfterComma(onlyComma) {
        var afterComma = onlyComma.split(".").slice(1).join("");
        if (onlyComma.match(/\./)) return "." + afterComma;
        else return "";
    }
}


function getNextPosition(field, selectPos, formattedValue, config, offset = 0) {
    var { start, end } = getSelection(field, config, offset);
    var allowedRange = getAllowedPositionRange(field, config);
    var lengthDifference = getLengthDifference(field.value, formattedValue, config);
    var maximumPosition = allowedRange.end + lengthDifference;
    if (start !== end) {
        return tools.between(start + selectPos, 0, maximumPosition);
    }
    else {
        return tools.between(start + lengthDifference + (selectPos === 0 ? 1 : 0), 0, maximumPosition);
    }
}

function convertString(value, format, suffix = null) {
    if (format === "integer") {
        return suffix !== null && suffix.length > 0
            ? onlyInteger(value.split(suffix)[0].trim())
            : onlyInteger(value);
    }
    else if (format === 'decimal') {
        return onlyDecimal(value);
    }
    else if (format === "phone") {
        return filterOnRegExp(value, /[ 0-9\+\-]/);
    }
    else return value;
}

function getLengthDifference(left, right, config) {
    var expression = config.suffix ? new RegExp(" *" + config.suffix.replace('+', '')) : expression = new RegExp(" *" + config.suffix)
    var suffixLength = (config.suffix || "").length;
    var [leftLength, rightLength] = [left, right].map(text => {
        return text.replace(expression, "").length;
    });

    return rightLength - leftLength;

}

const formatter = require('./formatter').formatter();
function format(value, config) {
    return formatter(value, config.format, config.suffix, config.decimals, config.thousands);
}
